import React from 'react'
import './portfolio.css'
// Project images 
import IMG1 from '../../assets/portfolio1.jpg'
import IMG2 from '../../assets/portfolio2.jpg'
import IMG3 from '../../assets/portfolio3.jpg'
import IMG4 from '../../assets/portfolio4.jpg'
import IMG5 from '../../assets/portfolio5.png'
import IMG6 from '../../assets/portfolio6.jpg'


const Portfolio = () => {
  return (
    <section id='portfolio'>
      <h5>My Recent Work</h5>
      <h2>Portfolio</h2>

      <div className="container portfolio_container">
        <article className='portfolio_item'>
          <div className="portfolio_item-image">
          <img src={IMG1} alt="" />
          </div>
          <h3>Adventure Website</h3>
          <div className="portfolio_item-cta">
          <a href="https://github.com" className='btn'>Github</a>
          <a href="https://naeemkhan456.github.io/Adventure/" className='btn btn-primary'>Live Demo</a>
          </div>
        </article>

        <article className='portfolio_item'>
          <div className="portfolio_item-image">
          <img src={IMG2} alt="" />
          </div>
          <h3>Dashboard Design</h3>
          <div className="portfolio_item-cta">
          <a href="https://github.com" className='btn'>Github</a>
          <a href="https://naeemkhan456.github.io/simple-dashboard/" className='btn btn-primary'>Live Demo</a>
          </div>
        </article>        

        <article className='portfolio_item'>
          <div className="portfolio_item-image">
          <img src={IMG3} alt="" />
          </div>
          <h3>Figma Design Zoulu Massaage Project</h3>
          <div className="portfolio_item-cta">
          <a href="https://github.com" className='btn'>Github</a>
          <a href="https://naeemkhan456.github.io/Zoulu-figma/" className='btn btn-primary'>Live Demo</a>
          </div>
        </article>

        <article className='portfolio_item'>
          <div className="portfolio_item-image">
          <img src={IMG4} alt="" />
          </div>
          <h3>Place Finder by Zipcode</h3>
          <div className="portfolio_item-cta">
          <a href="https://github.com" className='btn'>Github</a>
          <a href="https://placefinderbyzipcode.netlify.app" className='btn btn-primary'>Live Demo</a>
          </div>
        </article>

        <article className='portfolio_item'>
          <div className="portfolio_item-image">
          <img src={IMG5} alt="" />
          </div>
          <h3>Documentation Website</h3>
          <div className="portfolio_item-cta">
          <a href="https://github.com" className='btn'>Github</a>
          <a href="https://naeemkhan456.github.io/Documentation/" className='btn btn-primary'>Live Demo</a>
          </div>
        </article>

        <article className='portfolio_item'>
          <div className="portfolio_item-image">
          <img src={IMG6} alt="" />
          </div>
          <h3>Calculator</h3>
          <div className="portfolio_item-cta">
          <a href="https://github.com" className='btn'>Github</a>
          <a href="https://react-appcalculator.netlify.app" className='btn btn-primary'>Live Demo</a>
          </div>
        </article>

        <article className='portfolio_item'>
          <div className="portfolio_item-image">
          <img src={IMG6} alt="" />
          </div>
          <h3>Weather App</h3>
          <div className="portfolio_item-cta">
          <a href="https://github.com" className='btn'>Github</a>
          <a href="https://weather-app-456.netlify.app" className='btn btn-primary'>Live Demo</a>
          </div>
        </article>

        <article className='portfolio_item'>
          <div className="portfolio_item-image">
          <img src={IMG6} alt="" />
          </div>
          <h3>My Portfolio</h3>
          <div className="portfolio_item-cta">
          <a href="https://github.com" className='btn'>Github</a>
          <a href="https://naeemkhan456.github.io/naeemkhan/" className='btn btn-primary'>Live Demo</a>
          </div>
        </article>
      </div>
    </section>
  )
}

export default Portfolio